'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _table = require('./table');

var _numberFormatting = require('../common/utils/number-formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Trophy = function Trophy() {
  return _react2.default.createElement('i', { className: 'fa fa-trophy' });
};

var Score = function Score(_ref) {
  var irish = _ref.irish,
      score = _ref.score,
      props = _objectWithoutProperties(_ref, ['irish', 'score']);

  return irish ? _react2.default.createElement(
    _table.Cell,
    _extends({ left: true, flex: 20 }, props),
    (0, _numberFormatting.getOrdinal)(score.placement),
    ' - ',
    (0, _numberFormatting.padNumber)(score.computedTotal, 1),
    _react2.default.createElement('br', null),
    '(' + (0, _numberFormatting.padNumber)(score.total, 1) + ')'
  ) : _react2.default.createElement(
    _table.Cell,
    _extends({ left: true, flex: 20 }, props),
    (0, _numberFormatting.padNumber)(score.total, 1)
  );
};

var AdjudicatorHeader = function AdjudicatorHeader(_ref2) {
  var irish = _ref2.irish,
      name = _ref2.name,
      props = _objectWithoutProperties(_ref2, ['irish', 'name']);

  return irish ? _react2.default.createElement(
    _table.Cell,
    _extends({ left: true, flex: 20 }, props),
    name,
    _react2.default.createElement('br', null),
    '(total points)'
  ) : _react2.default.createElement(
    _table.Cell,
    _extends({ right: true, flex: 20 }, props),
    name
  );
};

var PlacementTable = function PlacementTable(_ref3) {
  var _ref3$persons = _ref3.persons,
      persons = _ref3$persons === undefined ? [] : _ref3$persons,
      _ref3$adjudicators = _ref3.adjudicators,
      adjudicators = _ref3$adjudicators === undefined ? [] : _ref3$adjudicators,
      _ref3$irishPoints = _ref3.irishPoints,
      irishPoints = _ref3$irishPoints === undefined ? false : _ref3$irishPoints,
      highlightPerson = _ref3.highlightPerson,
      showAdjudicators = _ref3.showAdjudicators;

  var adjudicatorHeaders = showAdjudicators ? adjudicators.map(function (a) {
    return _react2.default.createElement(AdjudicatorHeader, { key: a.get('id'),
      irish: irishPoints,
      name: a.get('fname') + ' ' + a.get('lname')
    });
  }) : null;

  var rows = persons.map(function (person) {
    return _react2.default.createElement(
      _table.Row,
      { style: { backgroundColor: highlightPerson === person.id ? '#FFFDE7' : '' } },
      _react2.default.createElement(
        _table.Cell,
        { center: true, flex: 1 },
        person.score.placed ? _react2.default.createElement(Trophy, null) : null
      ),
      _react2.default.createElement(
        _table.Cell,
        { center: true, flex: 5 },
        person.score.placement
      ),
      _react2.default.createElement(
        _table.Cell,
        { flex: 20 },
        person.competitor + ' - ' + person.fname + ' ' + person.lname
      ),
      showAdjudicators ? adjudicators.map(function (a) {
        return _react2.default.createElement(Score, { key: a.get('id'),
          irish: irishPoints,
          score: person.scores[a.get('id')] || 0
        });
      }) : null,
      irishPoints ? _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 10 },
        person.score.computedTotal.toFixed(1),
        _react2.default.createElement('br', null),
        '(',
        person.score.total.toFixed(1),
        ')'
      ) : _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 5 },
        person.score.computedTotal.toFixed(1)
      )
    );
  });

  return _react2.default.createElement(
    _table.Table,
    null,
    _react2.default.createElement(
      _table.Header,
      null,
      _react2.default.createElement(_table.Cell, { center: true, flex: 1 }),
      _react2.default.createElement(
        _table.Cell,
        { center: true, flex: 5 },
        'Place'
      ),
      _react2.default.createElement(
        _table.Cell,
        { flex: 20 },
        'Competitor'
      ),
      adjudicatorHeaders,
      irishPoints ? _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 10 },
        'Irish Points',
        _react2.default.createElement('br', null),
        '(total points)'
      ) : _react2.default.createElement(
        _table.Cell,
        { right: true, flex: 5 },
        'Total'
      )
    ),
    rows
  );
};

PlacementTable.propTypes = {
  persons: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
  highlightPerson: _react2.default.PropTypes.string,
  showAdjudicators: _react2.default.PropTypes.bool,
  adjudicators: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
  irishPoints: _react2.default.PropTypes.bool
};

exports.default = PlacementTable;


//////////////////
// WEBPACK FOOTER
// ./result-list/placement-table.js
// module id = 508
// module chunks = 0